import React, { useState } from 'react';
import { Card, CardBody, Row, Col, Button, Input, FormGroup } from 'reactstrap';
import SelectField from "../Utils/SelectField"
import { LabelText } from '../Utils/Input';

const ResourceOverrideCard = ({
  resourceOverrides,
  setResourceOverrides,
  resourceOptions
}) => {
  const handleAdd = () => {
    setResourceOverrides(prev => [...prev, { resourceName: null, value: '' }]);
  };

  const handleRemove = (index) => {
    setResourceOverrides(prev => prev.filter((_, i) => i !== index));
  };

  const handleResourceChange = (index, selectedOption) => {
    setResourceOverrides(prev =>
      prev.map((r, i) =>
        i === index ? { ...r, resourceName: selectedOption } : r
      )
    );
  };

  const handleValueChange = (index, value) => {
    setResourceOverrides(prev =>
      prev.map((r, i) =>
        i === index ? { ...r, value } : r
      )
    );
  };

  const handleClearValue = (index) => {
    setResourceOverrides(prev =>
      prev.map((r, i) =>
        i === index ? { resourceName:null, value: '' } : r
      )
    );
  }
  return (
   <div>
        <h5 className="fs-16 fw-bold text-black">Resource Override</h5>
        <Row>
          <Col xs={6} lg={3} sm={6}>
            <LabelText
              htmlFor={"resourceName"}
              className={"text-danger"}
              displayText={
                "Resource Name"
              }
            />
          </Col>
          <Col xs={6} lg={3} sm={6}>
            <LabelText
              htmlFor={"value"}
              className={"text-danger"}
              displayText={
                "Value"
              }
            />
          </Col>
        </Row>

        {resourceOverrides.map((resource, index) => {
          const alreadySelected = resourceOverrides
            .filter((_, i) => i !== index)
            .map(r => r.resourceName?.value);

          const filteredOptions = resourceOptions
            .filter(option => !alreadySelected.includes(option))
            .map(option => ({ label: option, value: option }));

          return (
            <Row className="mb-3" key={index}>
              <Col xs={6} lg={3} sm={6}>
                <FormGroup>
                  <SelectField
                    name={`resourceName-${index}`}
                    value={resource.resourceName}
                    options={filteredOptions}
                    handleChange={(selectedOption) =>
                      handleResourceChange(index, selectedOption)
                    }
                    placeholder=""
                    isRVStyle={true}
                    isClearable={true}
                  />
                </FormGroup>
              </Col>

              <Col xs={6} lg={3} sm={6}>
                <FormGroup>
                  <Input
                    type="text"
                    value={resource.value}
                    onChange={(e) => handleValueChange(index, e.target.value)}
                    placeholder=""
                  />
                </FormGroup>
              </Col>
              <Col xs={6} lg={3} sm={6}>
                {index === 0 ? <>
                {resource.resourceName!==null && resource.value != "" ? <div className="d-flex align-items-center">
                    <Button
                      color="link"
                      className="link-danger fs-4 p-0 border-0 bg-transparent shadow-none"
                      style={{ boxShadow: "none" }}
                      onClick={handleAdd}
                    >
                      <i class="ri-add-circle-line fs-16 text-danger"></i>
                    </Button>
                   <Button
                      color="link"
                      className="link-danger fs-4 p-0 border-0 bg-transparent shadow-none"
                      style={{ boxShadow: "none" }}
                      onClick={() => handleClearValue(index)}
                    >
                    <i class="ri-close-line fw-bold align-middle fs-16 ms-2 text-red"></i>
                    </Button>

                  </div>:""}
                
                </> : <>
                {resource.resourceName!==null && resource.value != ""?<div className="d-flex align-items-center">
                    <Button
                      color="link"
                      className="link-danger fs-4 p-0 border-0 bg-transparent shadow-none"
                      style={{ boxShadow: "none" }}
                      onClick={handleAdd}
                    >
                      <i class="ri-add-circle-line fs-16 text-danger"></i>
                    </Button>
                   <Button
                      color="link"
                      className="link-danger fs-4 p-0 border-0 bg-transparent shadow-none"
                      style={{ boxShadow: "none" }}
                      onClick={() => handleClearValue(index)}
                    >
                    <i class="ri-close-line fw-bold align-middle fs-16 ms-2 text-red"></i>
                    </Button>

                  </div> :<div className="d-flex align-items-center">
                  <Button
                  color="link"
                  className="link-danger fs-4 p-0 border-0 bg-transparent shadow-none"
                  style={{ boxShadow: "none" }}
                  onClick={() => handleRemove(index)}
                >
                  <i data-testid="delete" className="ri-delete-bin-5-line"></i>
                </Button>
                  </div>}
               
                </>

                }
              </Col>
            </Row>
          );
        })}
      </div>
  );
};

export default ResourceOverrideCard;